/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_revcomp_length = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Length: ${i?.n} bases`)
};

const es_revcomp_length = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Longitud: ${i?.n} bases`)
};

const de_revcomp_length = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Länge: ${i?.n} Basen`)
};

const nl_revcomp_length = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lengte: ${i?.n} basen`)
};

const fr_revcomp_length = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Longueur : ${i?.n} bases`)
};

const it_revcomp_length = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lunghezza: ${i?.n} basi`)
};

const pt_br2_revcomp_length = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Comprimento: ${i?.n} bases`)
};

const pt_revcomp_length = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Comprimento: ${i?.n} bases`)
};

const ja_revcomp_length = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`長さ: ${i?.n} 塩基`)
};

const zh_revcomp_length = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`长度：${i?.n} 个碱基`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ n: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const revcomp_length = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.revcomp_length(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("revcomp_length", locale)
	if (locale === "en") return en_revcomp_length(inputs)
	if (locale === "es") return es_revcomp_length(inputs)
	if (locale === "de") return de_revcomp_length(inputs)
	if (locale === "nl") return nl_revcomp_length(inputs)
	if (locale === "fr") return fr_revcomp_length(inputs)
	if (locale === "it") return it_revcomp_length(inputs)
	if (locale === "pt-BR") return pt_br2_revcomp_length(inputs)
	if (locale === "pt") return pt_revcomp_length(inputs)
	if (locale === "ja") return ja_revcomp_length(inputs)
	return zh_revcomp_length(inputs)
};